export default "__VITE_ASSET__Cbe_j7yM__"